import GeneralModal from "../../../../components/GeneralModal/GeneralModal";
import { toast } from "react-toastify";
import { useEquipmentUnarchivedMutation } from "../../../../store/builder/inspections.api";
import { useTranslation } from "../../../../hooks/useTranslation";

const UnArchiveEquipmentModal = ({
    equipment,
    setIsOpen,
    getEquipmentsInitial
}) => {
    const [
    unarchive,
    { isLoading: unarchiveEquipmentIsLoading },
    ] = useEquipmentUnarchivedMutation();
    const {t} = useTranslation();

    const handleActivate = () => {
        unarchive(equipment?.id).then((res) => {
            if (res?.data?.message) {
                toast.success(res?.data?.message);
            }
            if (res?.error) {
                toast.error(res?.error?.data?.message);
            }
            setIsOpen(false);
            getEquipmentsInitial();
        });
    }

    return (
        <GeneralModal
            title={t('equipmentTable.modals.unarchive.title')}
            onClose={() => setIsOpen(false)}
            onSubmit={handleActivate}
            submitTitle={t('equipmentTable.actions.unarchive')}
            btnType='save'
            disableSubmit={unarchiveEquipmentIsLoading}
        >
            <div className='modal__content-body'>
                <p>{t('equipmentTable.messages.unarchiveEquipment')}</p>
            </div>
        </GeneralModal>
    )
}

export default UnArchiveEquipmentModal;